// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Package from '../_raw/service/icon_package.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Package);
